export default {
    // import.meta.env.DEV é true no `npm run dev` (Vite) e false no build de produção
    baseUrl: import.meta.env.DEV ? 'https://localhost:7191' : 'https://apierp.hostmundo.net'
}

